import React from 'react';
import PropTypes from 'prop-types';
import editMessages from './simulatedEditAbilityConfirmationModalMessages';
import addMessages from './simulatedAddAbilityConfirmationModalMessages';
import approveMessages from './simulatedApproveAbilityConfirmationModalMessages';
import reproveMessages from './simulatedReproveAbilityConfirmationModalMessages';

import { FormattedMessage } from 'react-intl';
import { Modal } from 'sa-ui/';
import AbilityModalType from './simulatedAbilityModalType';

function getMessages(type) {
  switch (type) {
    case AbilityModalType.ADD:
      return addMessages;
    case AbilityModalType.EDIT:
      return editMessages;
    case AbilityModalType.APPROVE:
      return approveMessages;
    case AbilityModalType.REPROVE:
      return reproveMessages;
    default:
      return addMessages;
  }
}

const SimulatedAbilityConfirmationModal = props => {
  const messages = getMessages(props.type);
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="ti-thumb-up"
      title={<FormattedMessage {...messages.title} />}
      subtitle={<FormattedMessage {...messages.subtitle} />}
      buttons={[
        {
          label: <FormattedMessage {...messages.continue} />,
          onClick: props.onContinue,
        },
      ]}
    />
  );
};

SimulatedAbilityConfirmationModal.propTypes = {};

SimulatedAbilityConfirmationModal.defaultProps = {
  type: AbilityModalType.ADD,
};

export default SimulatedAbilityConfirmationModal;
